import React from 'react'
import { Column, HowItWorks, Row, StepCard, StepIcon } from './HomeForm.styles'
import { Typography } from '@chilecompra/react-kit/components'

/**
 * The HowItWorksSection's component.
 */
const HowItWorksSection = () => {
  return (
    <HowItWorks>
      <Row columnSpacing={{ md: 5 }} rowSpacing={5}>
        <Column xs={12}>
          <Typography align="center" fontWeight="bold" variant="h2">
            ¿Cómo funciona?
          </Typography>
        </Column>
      </Row>
      <Row columnSpacing={{ md: 5 }} rowSpacing={5}>
        <Column md={4} xs={12}>
          <StepCard align="center">
            <StepIcon>1</StepIcon>
            <Typography fontWeight="bold" margin="30px 0" variant="h4">
              Ingresa a la aerolínea
            </Typography>
            <Typography fontSize="15px" variant="body1">
              A través de los accesos que se encuentran a continuación podrás ingresar a cada aerolínea con tus
              credenciales de Mercado&nbsp;Público.
            </Typography>
          </StepCard>
        </Column>
        <Column md={4} xs={12}>
          <StepCard align="center">
            <StepIcon>2</StepIcon>
            <Typography fontWeight="bold" margin="30px 0" variant="h4">
              Genera tu reserva de pasajes
            </Typography>
            <Typography fontSize="15px" variant="body1">
              Realiza la reserva en la plataforma de la aerolínea. Una vez realizada la reserva se creará una nueva
              orden de compra en estado Guardada en Mercado&nbsp;Público.
            </Typography>
          </StepCard>
        </Column>
        <Column md={4} xs={12}>
          <StepCard align="center">
            <StepIcon>3</StepIcon>
            <Typography fontWeight="bold" margin="30px 0" variant="h4">
              Autoriza y envía la orden de compra
            </Typography>
            <Typography fontSize="15px" variant="body1">
              Recuerda que debes autorizar y validar el presupuesto de la orden de compra generada. Luego debes enviarla
              al proveedor para hacer efectiva tu reserva y generar el ticket del pasaje.
            </Typography>
          </StepCard>
        </Column>
      </Row>
    </HowItWorks>
  )
}

export default HowItWorksSection
